import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { ForecastWindlogProviderAvailabilityService } from "app/shared/services/data-services/forecast/windlog-provider-availability/forecast-windlog-provider-abailability";

export const ForecastProviderGuard: CanActivateFn = () => {
  const forecastWindlogProviderAvailabilityService = inject(ForecastWindlogProviderAvailabilityService);
  return forecastWindlogProviderAvailabilityService.getParksWithWindlogForecastAvailableQuery();

}